Vendd.Scripts.load(function () {

    var $wrapper = $('.x-tab-product-list');

    if ($wrapper.length < 1) return;

    var $tabTitle = $('[data-tab]', $wrapper);
    var $tabContent = $('[data-list]', $wrapper);

    $tabTitle.click(function () {

        var thisTab = $(this);
        var thisTabIndex = thisTab.data('tab');
        var thisTabContainer = thisTab.closest('.tabs-container');
        if (thisTab.hasClass('active')) return;
        $(thisTabContainer).find('li .tab.active').removeClass('active');
        thisTab.addClass('active');
        $(thisTabContainer).siblings('[data-list]').removeClass('active');
        $(thisTabContainer).siblings('[data-list=' + thisTabIndex + ']').addClass('active');
    });

});




